"use client";

import React from "react";
import { MapPin } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const projects = [];
export default function ServiceAreasList() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="234121" id="service-areas-list" className="bg-background text-foreground py-24 md:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={ref} className={`mb-16 md:mb-24 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          
          
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6">
          {projects.map((project, i) => <div key={i} data-index={i} className={`group relative overflow-hidden rounded-lg bg-card shadow-md border border-transparent transition-all duration-500 hover:border-primary ${project.colSpan} ${project.height}`}>
              {}
              <img src={project.image} alt={project.title} className="absolute inset-0 w-full h-full object-cover grayscale transition-all duration-700 ease-in-out group-hover:grayscale-0 group-hover:scale-105" />

              {}
              <div className="absolute inset-0 bg-secondary/90 backdrop-blur-sm translate-y-full transition-transform duration-500 ease-in-out group-hover:translate-y-0 flex flex-col justify-end p-8 md:p-12 shadow-[inset_0_0_40px_rgba(0,0,0,0.5)]">
                <div className="transform translate-y-8 opacity-0 transition-all duration-500 delay-100 group-hover:translate-y-0 group-hover:opacity-100">
                  <h3 className="font-default text-2xl md:text-3xl lg:text-4xl font-bold text-primary mb-3">
                    {project.title}
                  </h3>
                  <div className="flex items-center text-secondary-foreground/80 font-medium tracking-wide">
                    <MapPin className="w-5 h-5 mr-2 text-primary" />
                    <span className="font-sans">{project.location}</span>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}